import { z } from 'zod';

/**
 * Runtime-конфигурация окружения (api-and-network.md: «конфиг не вшивается в бандл»).
 * В production файл /config.js генерируется при старте контейнера и задаёт
 * window.__GWINE_ADMIN_CONFIG__; в dev — public/config.js. Фолбэк — import.meta.env.
 */
declare global {
  interface Window {
    __GWINE_ADMIN_CONFIG__?: unknown;
  }
}

const runtimeConfigSchema = z.object({
  apiBaseUrl: z.string().min(1).optional(),
});

export interface RuntimeConfig {
  /** Базовый URL API, например `/api/v1` (vite-proxy → бэкенд :8040). */
  apiBaseUrl: string;
}

const DEFAULT_API_BASE_URL = '/api/v1';

function readWindowConfig(): z.infer<typeof runtimeConfigSchema> {
  if (typeof window === 'undefined') return {};
  const parsed = runtimeConfigSchema.safeParse(window.__GWINE_ADMIN_CONFIG__ ?? {});
  return parsed.success ? parsed.data : {};
}

let cached: RuntimeConfig | null = null;

export function getRuntimeConfig(): RuntimeConfig {
  if (!cached) {
    const fromWindow = readWindowConfig();
    cached = {
      apiBaseUrl:
        fromWindow.apiBaseUrl || import.meta.env.VITE_API_BASE_URL || DEFAULT_API_BASE_URL,
    };
  }
  return cached;
}
